import _defineProperty from "/home/kms-config/ikos-kms-v2/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { createStyles } from '@mantine/styles';
var useStyles = createStyles(function (_theme, _ref) {
  var orientation = _ref.orientation,
    buttonBorderWidth = _ref.buttonBorderWidth;
  return {
    root: {
      display: "flex",
      flexDirection: orientation === "vertical" ? "column" : "row",
      "& [data-button]": {
        "&:first-of-type": _defineProperty(_defineProperty({
          borderBottomRightRadius: 0
        }, orientation === "vertical" ? "borderBottomLeftRadius" : "borderTopRightRadius", 0), orientation === "vertical" ? "borderBottomWidth" : "borderRightWidth", buttonBorderWidth / 2),
        "&:last-of-type": _defineProperty(_defineProperty({
          borderTopLeftRadius: 0
        }, orientation === "vertical" ? "borderTopRightRadius" : "borderBottomLeftRadius", 0), orientation === "vertical" ? "borderTopWidth" : "borderLeftWidth", buttonBorderWidth / 2),
        "&:not(:first-of-type):not(:last-of-type)": _defineProperty(_defineProperty({
          borderRadius: 0
        }, orientation === "vertical" ? "borderTopWidth" : "borderLeftWidth", buttonBorderWidth / 2), orientation === "vertical" ? "borderBottomWidth" : "borderRightWidth", buttonBorderWidth / 2),
        "& + [data-button]": _defineProperty(_defineProperty({}, orientation === "vertical" ? "marginTop" : "marginLeft", -buttonBorderWidth), "@media (min-resolution: 192dpi)", _defineProperty({}, orientation === "vertical" ? "marginTop" : "marginLeft", 0))
      }
    }
  };
});
export default useStyles;